{
  "__review_clinicalData": "Backend/clinician-authored API data (allergen/medication/problem/provider/result names, values, units, ranges, comments, message bodies) — Phase 9, do not translate",
  "enums": {
    "appointmentStatus": {
      "scheduled": "Đã lên lịch",
      "confirmed": "Đã xác nhận",
      "completed": "Đã hoàn thành",
      "cancelled": "Đã hủy",
      "no-show": "Không đến khám",
      "checked-in": "Đã làm thủ tục"
    },
    "resultStatus": {
      "final": "Chính thức",
      "preliminary": "Sơ bộ",
      "corrected": "Đã chỉnh sửa"
    },
    "allergySeverity": {
      "severe": "Nghiêm trọng",
      "high": "Cao",
      "moderate": "Trung bình"
    },
    "nationalIdType": {
      "NRIC": "NRIC (Singapore)",
      "HKID": "HKID (Hồng Kông)",
      "MyKad": "MyKad (Malaysia)",
      "Aadhaar": "Aadhaar (Ấn Độ)",
      "KTP": "KTP (Indonesia)",
      "Passport": "Hộ chiếu"
    },
    "messageSenderType": {
      "provider": "Nhà cung cấp",
      "patient": "Bệnh nhân"
    }
  },
  "form": {
    "validation": {
      "passwordMismatch": "Mật khẩu không khớp",
      "passwordMinLength": "Mật khẩu phải có ít nhất 8 ký tự"
    }
  },
  "labels": {
    "abnormal": "Bất thường"
  },
  "pages": {
    "layout": {
      "nav": {
        "myHealth": "Sức khỏe của tôi",
        "results": "Kết quả",
        "appointments": "Lịch hẹn",
        "messages": "Tin nhắn",
        "forms": "Biểu mẫu"
      },
      "signOut": "Đăng xuất",
      "signOutAria": "Đăng xuất",
      "navAria": "Điều hướng cổng thông tin",
      "footer": "Cổng thông tin Bệnh nhân VynaEMR — FLOSTEL Healthcare IT"
    },
    "login": {
      "subtitle": "Cổng thông tin Bệnh nhân",
      "labels": {
        "email": "Email",
        "password": "Mật khẩu"
      },
      "placeholders": {
        "email": "you@example.com",
        "password": "Nhập mật khẩu của bạn"
      },
      "button": {
        "signIn": "Đăng nhập",
        "signingIn": "Đang đăng nhập..."
      },
      "toast": {
        "welcome": "Chào mừng trở lại!",
        "invalid": "Email hoặc mật khẩu không hợp lệ"
      },
      "links": {
        "noAccount": "Chưa có tài khoản?",
        "register": "Đăng ký"
      }
    },
    "dashboard": {
      "greeting": {
        "morning": "Chào buổi sáng",
        "afternoon": "Chào buổi chiều",
        "evening": "Chào buổi tối",
        "fallbackName": "bạn"
      },
      "subtitle": "Dưới đây là tóm tắt sức khỏe của bạn.",
      "error": "Không thể tải tóm tắt sức khỏe của bạn. Vui lòng thử lại sau.",
      "demographics": {
        "ageLabel": "Tuổi {{age}}",
        "bloodTypeLabel": "Nhóm máu: {{bloodType}}"
      },
      "quickLinks": {
        "results": "Kết quả",
        "appointments": "Lịch hẹn",
        "messages": "Tin nhắn",
        "forms": "Biểu mẫu"
      },
      "sections": {
        "allergies": "Dị ứng",
        "activeMedications": "Thuốc đang sử dụng",
        "activeProblems": "Vấn đề sức khỏe hiện tại",
        "upcomingAppointments": "Lịch hẹn sắp tới",
        "recentResults": "Kết quả gần đây",
        "immunizations": "Lịch sử tiêm chủng",
        "emergencyContact": "Liên hệ khẩn cấp"
      },
      "states": {
        "noAllergies": "Không có dị ứng nào được ghi nhận.",
        "noMedications": "Không có thuốc đang sử dụng.",
        "noAppointments": "Không có lịch hẹn sắp tới.",
        "noResults": "Không có kết quả gần đây."
      },
      "moreCount": "+{{count}} mục khác",
      "sinceDate": "từ {{date}}",
      "doseNumber": "Mũi {{number}}",
      "viewAll": "Xem tất cả",
      "providerTBD": "Chưa xác định bác sĩ"
    },
    "register": {
      "subtitle": "Tạo tài khoản của bạn",
      "labels": {
        "fullName": "Họ và tên",
        "email": "Email",
        "dateOfBirth": "Ngày sinh",
        "phone": "Điện thoại",
        "mrn": "MRN (Số hồ sơ bệnh án)",
        "idType": "Loại giấy tờ tùy thân",
        "idNumber": "Số giấy tờ tùy thân",
        "password": "Mật khẩu",
        "confirmPassword": "Xác nhận mật khẩu"
      },
      "placeholders": {
        "fullName": "Họ và tên của bạn",
        "email": "you@example.com",
        "phone": "+65 9123 4567",
        "mrn": "e.g. P0000000001",
        "idNumber": "Số giấy tờ tùy thân của bạn",
        "password": "Ít nhất 8 ký tự",
        "confirmPassword": "Nhập lại mật khẩu của bạn",
        "selectIdType": "Chọn..."
      },
      "mrnHint": "Để liên kết tài khoản của bạn với hồ sơ bệnh án, vui lòng cung cấp MRN hoặc số giấy tờ tùy thân quốc gia.",
      "button": {
        "createAccount": "Tạo Tài khoản",
        "creatingAccount": "Đang tạo tài khoản..."
      },
      "toast": {
        "success": "Đăng ký thành công. Vui lòng đăng nhập.",
        "failure": "Đăng ký thất bại. Vui lòng thử lại."
      },
      "links": {
        "haveAccount": "Đã có tài khoản?",
        "signIn": "Đăng nhập"
      },
      "aria": {
        "dateOfBirth": "Ngày sinh"
      }
    },
    "appointments": {
      "title": "Lịch hẹn",
      "subtitle": "Xem và quản lý các lịch hẹn của bạn",
      "error": "Không thể tải lịch hẹn. Vui lòng thử lại sau.",
      "sections": {
        "upcoming": "Sắp tới",
        "past": "Đã qua"
      },
      "states": {
        "noUpcoming": "Không có lịch hẹn sắp tới.",
        "noPast": "Không có lịch hẹn đã qua."
      },
      "reasonLabel": "Lý do: {{reason}}",
      "instructionsLabel": "Hướng dẫn: {{instructions}}",
      "durationMinutes": "{{minutes}} phút",
      "actions": {
        "cancel": "Hủy",
        "confirmCancel": "Xác nhận",
        "cancelling": "Đang hủy...",
        "keep": "Giữ lại"
      },
      "toast": {
        "cancelSubmitted": "Đã gửi yêu cầu hủy. Đội ngũ chăm sóc sẽ xác nhận với bạn.",
        "cancelFailed": "Không thể hủy lịch hẹn. Vui lòng gọi cho phòng khám."
      }
    },
    "results": {
      "title": "Kết quả của tôi",
      "subtitle": "Xem kết quả xét nghiệm và chẩn đoán hình ảnh của bạn",
      "error": "Không thể tải kết quả. Vui lòng thử lại sau.",
      "referenceRange": "(Tham chiếu: {{range}})",
      "states": {
        "noResults": "Chưa có kết quả nào."
      }
    },
    "messages": {
      "title": "Tin nhắn",
      "subtitle": "Trao đổi với đội ngũ chăm sóc của bạn",
      "error": "Không thể tải tin nhắn. Vui lòng thử lại sau.",
      "fromSender": "từ {{name}}",
      "labels": {
        "subject": "Chủ đề",
        "message": "Tin nhắn",
        "reply": "Trả lời"
      },
      "placeholders": {
        "subject": "Chủ đề tin nhắn",
        "message": "Nhập tin nhắn của bạn...",
        "reply": "Nhập nội dung trả lời của bạn..."
      },
      "actions": {
        "newMessage": "Tin nhắn mới",
        "back": "Quay lại danh sách tin nhắn",
        "sendMessage": "Gửi tin nhắn",
        "sendReply": "Gửi trả lời",
        "sending": "Đang gửi..."
      },
      "states": {
        "noMessages": "Chưa có tin nhắn."
      },
      "thread": {
        "fromSenderWithType": "Từ {{name}} ({{type}})"
      },
      "compose": {
        "title": "Tin nhắn mới",
        "subtitle": "Tin nhắn của bạn sẽ được gửi đến đội ngũ chăm sóc."
      },
      "toast": {
        "sent": "Đã gửi tin nhắn",
        "sendFailed": "Gửi tin nhắn không thành công"
      }
    },
    "forms": {
      "title": "Biểu mẫu",
      "subtitle": "Hoàn thành các biểu mẫu và bảng hỏi cần thiết",
      "error": "Không thể tải biểu mẫu. Vui lòng thử lại sau.",
      "sections": {
        "pending": "Chưa hoàn thành",
        "completed": "Đã hoàn thành"
      },
      "labels": {
        "required": "Bắt buộc"
      },
      "placeholders": {
        "select": "Chọn..."
      },
      "actions": {
        "fillOut": "Điền",
        "back": "Quay lại biểu mẫu",
        "submit": "Gửi biểu mẫu",
        "submitting": "Đang gửi..."
      },
      "states": {
        "noPending": "Không có biểu mẫu nào chưa hoàn thành.",
        "noCompleted": "Không có biểu mẫu nào đã hoàn thành.",
        "noFields": "Biểu mẫu này không có trường nào để điền."
      },
      "toast": {
        "submitted": "Đã gửi biểu mẫu thành công",
        "submitFailed": "Gửi biểu mẫu không thành công"
      }
    }
  }
}
